import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHorizontalAlignmentCenter: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="horizontal-alignment-center"><path d="M3.75 12H6.75M17.25 12H20.25M10.25 12H13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 4.75V19.75H10.25V4.75H6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 6.75V17.25H17.25V6.75H13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconHorizontalAlignmentCenter;
